import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  BaseStatistic,
  BasketballStatistic,
  FootballStatistic,
  HandballStatistic,
  HockeyStatistic,
  RugbyStatistic,
  Team, Tournament,
  TournamentTeam,
  VolleyballStatistic,
} from '@mtgame/core';
import { getTournamentRoute } from '@config/routes';
import { DIVISION_QUERY_PARAM } from '@config/routing-map';

@Component({
  selector: 'mtg-tournament-team-card',
  templateUrl: './tournament-team-card.component.html',
  styleUrls: ['./tournament-team-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TournamentTeamCardComponent {
  @Input()
  team: Team;
  @Input()
  tournamentTeam: TournamentTeam;
  @Input()
  teamStatistic: BaseStatistic;
  @Input()
  usersCount: number;
  @Input()
  actualTournamentTeam: TournamentTeam;

  get tournament(): Tournament {
    return this.tournamentTeam.tournament;
  }

  printApplication(): void {
    window.open(`https://mtgame.ru/api/v1/tournament_team/${this.actualTournamentTeam.id}/application_file/?file_type=html`)
  }

  getTournamentRoute(): string[] {
    return getTournamentRoute(this.tournamentTeam.tournament.alias);
  }

  getDivisionQueryParams() {
    return {[DIVISION_QUERY_PARAM]: this.tournamentTeam.division.id};
  }

  get hockeyStatistic(): HockeyStatistic {
    return this.teamStatistic as HockeyStatistic;
  }

  get basketballStatistic(): BasketballStatistic {
    return this.teamStatistic as BasketballStatistic;
  }

  get volleyballStatistic(): VolleyballStatistic {
    return this.teamStatistic as VolleyballStatistic;
  }

  get handballStatistic(): HandballStatistic {
    return this.teamStatistic as HandballStatistic;
  }

  get footballStatistic(): FootballStatistic {
    return this.teamStatistic as FootballStatistic;
  }

  get rugbyStatistic(): RugbyStatistic {
    return this.teamStatistic as RugbyStatistic;
  }
}
